import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { references } from '@apexdesigner/schema-tools';

export const latestProcessDesign = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    designUuid: z
      .string()
      .nullable()
      .optional()
      .hidden()
      .describe('Unique identifier for this process across all versions'),

    name: z
      .string()
      .nullable()
      .optional()
      .describe('Internal name of the process'),

    displayName: z
      .string()
      .nullable()
      .optional()
      .describe('Human-readable name shown to users'),

    description: z
      .string()
      .nullable()
      .optional()
      .describe('Explanation of what this process does'),

    version: z
      .number()
      .nullable()
      .optional()
      .describe('Version number of this design'),

    suspended: z
      .boolean()
      .nullable()
      .optional()
      .describe('Whether new instances can be started from this design'),

    createdAt: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When this version was created'),

    updatedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When this version was last modified'),

    activeInstanceCount: z
      .number()
      .nullable()
      .optional()
      .describe('Number of running instances using this design'),

    errorInstanceCount: z
      .number()
      .nullable()
      .optional()
      .describe('Number of instances with errors using this design'),

    tenantId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Tenant'),

    tenant: references('Tenant'),
  })
  .describe(
    'Shows only the most recent version of each process design.\n\nReplaces the process-engine-library view to expose the tenant partition\ncolumn and apply the Tenant Scoped mixin.',
  )
  .as('LatestProcessDesign');

export { latestProcessDesign as latestProcessDesignSchema };
